import React from 'react';
import styles from './AdminTable.module.scss';
import { countries } from '@constants';
import FlagAU from 'src/assets/icons/icon_au.svg?react';
import FlagCA from 'src/assets/icons/icon_ca.svg?react';
import FlagUS from 'src/assets/icons/icon_us.svg?react';

type CountryFlagProps = {
  countryCode: string;
};

const getFlagIcon = (code: String) => {
  switch (code) {
    case "au": {
      return <FlagAU className={styles.flag}/>;
    }
    case "ca": {
      return <FlagCA className={styles.flag}/>;
    }
    case "us": {
      return <FlagUS className={styles.flag}/>;
    }
    default: {
      return null;
    }
  }
}

/**
 * CountryFlag - A component to display a country flag
 * 
 * This component takes a country code and displays the corresponding flag.
 * It uses the country code to determine which flag to display.
 */
const CountryFlag: React.FC<CountryFlagProps> = ({ countryCode }) => {
  // Extract the country code from the first two characters if it's a longer string (like a user ID)
  const code = countryCode.length > 2 ? countryCode.substring(0, 2).toLowerCase() : countryCode.toLowerCase();
  
  // Get the country name for the tooltip
  const countryName = countries[code.toUpperCase()] || 'Unknown';
  
  return (
    <div title={countryName}>
      {getFlagIcon(code)}
    </div>
  );
};

export default CountryFlag;
